import React from 'react';

const IconLoader = () => (


  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="64" height="64" class="bordered">
     <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
    
        <circle cx="12" cy="12" r="10" />
        <line x1="8" y1="12" x2="16" y2="12" />
        <polyline points="12 8, 16 12, 12 16" />
        </g>
          <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
      </g>
</svg>

  
);

export default IconLoader;
